module.exports = __webpack_public_path__ + "img/Icon-block-checkup-32px-paars.f2185671.svg";